import React from "react";
import { getErrorMessage } from "../../_store/okrPlansCoachStore";
import OpcSkeleton from "../OpcSkeleton/OpcSkeleton";

// Loading (a skeleton, CD26) and error states for the live coach screens.
export const OpcPageLoading = ({ kind }) => <OpcSkeleton kind={kind} />;

export const OpcPageError = ({
  error,
  onRetry,
  onBack,
  backLabel = "Back",
}) => (
  <div className="d-flex flex-column align-items-center justify-content-center opc-empty">
    <img
      src="/assets/images/agent-ligh-grey.svg"
      width={25}
      height={25}
      alt=""
    />
    <span className="fw-bold dark-grey small mt-4">
      {getErrorMessage(error)}
    </span>
    <div className="d-flex align-items-center gap-3 mt-3">
      {onBack ? (
        <button type="button" className="opc-pv-link" onClick={onBack}>
          {backLabel}
        </button>
      ) : null}
      {onRetry ? (
        <button type="button" className="opc-pv-link" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </div>
  </div>
);
